<template>
  <div>
      <van-datetime-picker
        v-model="currentDates"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm='confirm'
        @cancel='cancel'
      />
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name:'DateTimePicker',
  data(){
    return{
      currentDates:this.currentDate
    }
  },
  props:{
    minDate:{
      type:Date,
      default:''
    },
    maxDate:{
      type:Date,
      default:''
    },
    currentDate:{
      type:Date,
      default:''
    }
  },
  mounted(){
  },
  methods:{
    confirm(val){
      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      this.$emit('confirm',{
        data: this.data,
        value: `${year}-${month}-${day}`,
        showDatePicker:false
      })
    },
    cancel(){
      this.$emit('cancel',{
        showDatePicker:false
      })
    }
  }
};
</script>

<style>
</style>